import React, { useState, useRef, useCallback } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useResizeObserver } from "@wojtekmaj/react-hooks";
import { Spinner } from "components";
import { publicPath} from "request"
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/esm/Page/TextLayer.css";
import { useIntl } from "react-intl";

interface PdfViewerProps {
  pdfUrl: string;
}

const resizeObserverOptions = {};

const maxWidth = 650;

// pdfjs.GlobalWorkerOptions.workerSrc = publicPath + "/pdf.worker.min.js";
pdfjs.GlobalWorkerOptions.workerSrc = publicPath + "/pdf.worker.js";

// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export const PdfViewer: React.FC<PdfViewerProps> = ({ pdfUrl }) => {

  const { formatMessage } = useIntl();

  const [numPages, setNumPages] = useState<number | null>(null);
  const [containerWidth, setContainerWidth] = useState<number>(360);

  const containerRef = useRef<HTMLDivElement>(null);

  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries;
    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  useResizeObserver(containerRef.current, resizeObserverOptions, onResize);

  const onLoadSuccess = ({ numPages }: any): void => {
    setNumPages(numPages);
  };

  return (
    <div className="h-full overflow-y-auto" ref={containerRef}>
      <Document
        file={pdfUrl}
        onLoadSuccess={onLoadSuccess}
        loading={
          <Spinner
            extraSmall
            className={{ "border-gray999": true }}
            loadingText={formatMessage({ id: "product.manual.loading.pdf" })}
          />
        }
      >
        {Array.from(new Array(numPages), (_, index) => (
          <Page
            loading={null}
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={
              containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth
            }
          />
        ))}
      </Document>
    </div>
  );
};
